import React, { useState, useEffect } from "react";

function WorldMeshPanel(props) {
  const [visible, setVisible] = useState(props.visible);
  const [pointerThickness, setPointerThickness] = useState(props.settings?.pointerThickness || "medium");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setVisible(props.visible);
    if (props.settings?.pointerThickness) {
      setPointerThickness(props.settings.pointerThickness);
    }
  }, [props.visible, props.settings?.pointerThickness]);

  const updateChecked = (option) => {
    if (option === "autoRotate") {
      Inventum.labels.toggleAutoRotate(props.id);
    }
    props.getLabels();
  };

  const toggleLabelPointerVisibility = () => {
    const newVisibility = !visible;
    if (newVisibility && !props.labelVisible) {
      Inventum.labels.toggleVisible(props.id);
    }
    Inventum.labels.setPointerVisible(props.id, newVisibility);
    props.onPointerVisibilityChange(newVisibility);
    setVisible(newVisibility);
    props.getLabels();
  };

  const handlePointerThicknessChange = (thickness) => {
    setPointerThickness(thickness);
    Inventum.labels.setPointerThickness(props.id, thickness);
    props.getLabels();
  };

  return (
    <div>
      <div className="EditorDrawerItemHeader" onClick={() => setOpen(!open)}>
        <span className="PanelOpenStatus">{open ? "▾" : "▸"}</span>
        <span>Label Pointer</span>
      </div>
      {open && (
        <StyleDrawer
          {...props}
          visible={visible}
          pointerThickness={pointerThickness}
          handlePointerThicknessChange={handlePointerThicknessChange}
          toggleVisibility={toggleLabelPointerVisibility}
          updateChecked={updateChecked}
        />
      )}
    </div>
  );
}

function StyleDrawer(props) {
  return (
    <div className="MeshDrawerContainer">
      <div className="MeshSection">
        <div className="MeshSectionTitle">Visibility</div>
        <div className="MeshSectionContent">
          <ToggleLabelPointerVisibility visible={props.visible} toggleVisibility={props.toggleVisibility} />
        </div>
      </div>

      <div className="MeshSection">
        <div className="MeshSectionTitle">Thickness</div>
        <div className="MeshSectionContent">
          <PointerThicknessSelector
            visible={props.visible}
            pointerThickness={props.pointerThickness}
            handlePointerThicknessChange={props.handlePointerThicknessChange}
          />
        </div>
      </div>

      <div className="MeshSection">
        <div className="MeshSectionTitle">Behaviour</div>
        <div className="MeshSectionContent MeshGrid">
          <div className="MeshAutoContainer">
            <ToggleAutoRotate {...props} />
          </div>
        </div>
      </div>
    </div>
  );
}

function PointerThicknessSelector(props) {
  return (
    <div className="MeshInputRow">
      <div className="MeshInputLabel">Thickness</div>
      <div className="MeshThicknessButtons">
        <button
          className={`MeshThicknessButton ${props.pointerThickness === "thin" ? "active" : ""}`}
          onClick={() => props.handlePointerThicknessChange("thin")}
          disabled={!props.visible}
        >
          Thin
        </button>
        <button
          className={`MeshThicknessButton ${props.pointerThickness === "medium" ? "active" : ""}`}
          onClick={() => props.handlePointerThicknessChange("medium")}
          disabled={!props.visible}
        >
          Medium
        </button>
        <button
          className={`MeshThicknessButton ${props.pointerThickness === "thick" ? "active" : ""}`}
          onClick={() => props.handlePointerThicknessChange("thick")}
          disabled={!props.visible}
        >
          Thick
        </button>
      </div>
    </div>
  );
}

function ToggleLabelPointerVisibility(props) {
  return (
    <div className="MeshToggleRow">
      <label className="MeshToggleLabel">
        <input
          type="checkbox"
          className="MeshCheckbox"
          checked={props.visible}
          onChange={props.toggleVisibility}
        />
        <span className="MeshCheckboxIcon material-icons">
          {props.visible ? 'check_box' : 'check_box_outline_blank'}
        </span>
        <span>Label Pointer Visible</span>
      </label>
    </div>
  );
}

function ToggleAutoRotate(props) {
  return (
    <div className="MeshToggleRow">
      <label className="MeshToggleLabel">
        <input
          type="checkbox"
          className="MeshCheckbox"
          checked={props.autoRotate}
          onChange={() => props.updateChecked("autoRotate")}
        />
        <span className="MeshCheckboxIcon material-icons">
          {props.autoRotate ? 'check_box' : 'check_box_outline_blank'}
        </span>
        <span>Auto-Rotate</span>
      </label>
    </div>
  );
}

export { WorldMeshPanel };
